import { Provider } from 'react-redux';
import createStore from './utils/store';
import { BrowserRouter } from 'react-router-dom';
import Routers from './routers/Routers';
import LoadingProvider from './utils/loadingProvider';
import { ChakraProvider } from '@chakra-ui/react'
const App = () => {
  const store = createStore();
  return (
    <div className='container'>
    <ChakraProvider>
      <Provider store={store}>
        <LoadingProvider>
          <BrowserRouter>
            <Routers/>
          </BrowserRouter>
        </LoadingProvider>
      </Provider>
    </ChakraProvider>
    </div>
  );
}
export default App;